/**
 * Leaf module (no imports): safe to read at module-init time from anywhere,
 * including modules inside import cycles.
 */
export enum MED_FLOW {
  HRT = "hrt",
  CLINICAL = "clinical",
  HEALTH = "health",
}

export enum MED_SKU {
  BRANDED_ZEPBOUND_VIAL = "BRANDED_ZEPBOUND_VIAL",
  BRANDED_WEGOVY_PILL = "BRANDED_WEGOVY_PILL",
  BRANDED = "BRANDED",
  COMPOUNDED = "COMPOUNDED",
  COMPOUNDED_TIRZEPATIDE = "COMPOUNDED_TIRZEPATIDE",
  GENERIC_LIRAGLUTIDE = "GENERIC_LIRAGLUTIDE",
  ORALS_METFORMIN = "ORALS_METFORMIN",
  HRT_CREAM = "HRT_CREAM",
  HRT_PATCH = "HRT_PATCH",
  COMPOUNDED_MICRODOSE = "COMPOUNDED_MICRODOSE",
  COMPOUNDED_MICRODOSE_PROACTIVE_HEALTH_BIOMARKER = "COMPOUNDED_MICRODOSE_PROACTIVE_HEALTH_BIOMARKER",
  COMPOUNDED_MICRODOSE_TIRZEPATIDE = "COMPOUNDED_MICRODOSE_TIRZEPATIDE",
  MEMBERSHIP = "MEMBERSHIP",
}

export function isMedMembershipSku(sku: MED_SKU | null | undefined) {
  return sku === MED_SKU.MEMBERSHIP;
}

export function isBrandedMedSku(sku: MED_SKU | null | undefined) {
  return (
    sku === MED_SKU.BRANDED ||
    sku === MED_SKU.BRANDED_ZEPBOUND_VIAL ||
    sku === MED_SKU.BRANDED_WEGOVY_PILL
  );
}
